/**
  Styles for email preview iframe HTML.
  Styling matches server template `VarianceSupportingDataEmail.html`.
 */
export const varianceSupportingDataEmailTemplateCss = `
        * {
            margin: 0;
            padding: 0;
        }

        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
            background-color: #F3F3F3;
            color: #000100;
            line-height: 1.5;
        }

        .header-row {
            display: table;
            width: 100%;
            table-layout: fixed;
            margin-bottom: 0;
        }

        .header-block {
            display: table-cell;
            width: 33.33%;
            vertical-align: top;
            padding-right: 24px;
        }

        .header-block:last-child {
            padding-right: 0;
        }

        .header-block:nth-child(2) {
            padding-left: 8px;
            padding-right: 16px;
        }

        .header-block:nth-child(3) {
            padding-left: 8px;
        }

        .header-line {
            margin-bottom: 8px;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            letter-spacing: 0.15px;
            color: #303131;
        }

        .header-value {
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: 22px;
            color: #010100;
        }

        .title-bar {
            font-size: 24px;
            font-style: normal;
            font-weight: 900;
            line-height: 32px;
            color: #313131;
            margin: 40px 0;
        }

        .title-bar .incident-ref {
            font-size: 24px;
            font-style: normal;
            font-weight: 200;
        }

        .table-wrap {
            overflow-x: auto;
        }

        table {
            width: 100%;
            border-collapse: collapse;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
            color: #000000;
        }

        th {
            background-color: #E0E0E0;
            padding: 18px;
            text-align: left;
            font-weight: 600;
            color: #000000;
        }

        th .th-small {
            font-size: 14px;
            display: block;
        }

        td {
            padding: 10px 14px;
            border-bottom: 1px solid #B2B3B2;
        }

        tr.row-odd {
            background-color: #F3F3F3;
        }

        tr.row-even {
            background-color: #ffffff;
        }

        .video-link {
            color: #2C87BD;
            text-decoration: underline;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: 22px;
        }

        .ai-flag-cell {
            text-align: left;
            white-space: pre-wrap;
            max-width: 200px;
        }

        .email-body {
            margin-bottom: 24px;
            font-size: 16px;
            line-height: 2;
            color: #000100;
        }
        .data-container{
            background-color: #F3F3F3;
            padding: 12px;
        }
`;

/** Mock graph blocks below the transaction table (preview iframe only). */
export const mockEmailPreviewGraphCss = `
        .mock-analytics-charts {
            margin-top: 0;
        }

        .mock-graph-title {
            font-size: 24px;
            font-style: normal;
            font-weight: 900;
            line-height: 32px;
            color: #313131;
            margin: 32px 0 12px 0;
        }

        .mock-graph-section--first .mock-graph-title {
            margin-top: 24px;
        }

        .mock-graph-section .mock-chart-frame {
            border: 1px solid #B2B3B2;
            background: #ffffff;
            padding: 12px;
            border-radius: 4px;
        }

        .mock-graph-section .mock-chart-frame img {
            display: block;
            width: 100%;
            height: auto;
            max-width: 100%;
        }
`;

export const emailMockPreviewIframeStyles =
  varianceSupportingDataEmailTemplateCss + mockEmailPreviewGraphCss;

const emailSans =
  'font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;';

export const mockGraphEmailInlineStyles = {
  title: `font-size:24px;font-style:normal;font-weight:900;line-height:32px;color:#313131;margin:32px 0 12px 0;${emailSans}`,
  titleFirst: `font-size:24px;font-style:normal;font-weight:900;line-height:32px;color:#313131;margin:24px 0 12px 0;${emailSans}`,
  frame: 'border:1px solid #B2B3B2;background:#ffffff;padding:12px;border-radius:4px;',
  img: 'display:block;width:100%;height:auto;max-width:100%;',
} as const;
